var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5234 6.59082C12.5234 6.98243 12.679 7.358 12.9559 7.63491C13.2328 7.91182 13.6084 8.06738 14 8.06738C14.3916 8.06738 14.7672 7.91182 15.0441 7.63491C15.321 7.358 15.4766 6.98243 15.4766 6.59082C15.4766 6.19921 15.321 5.82364 15.0441 5.54673C14.7672 5.26982 14.3916 5.11426 14 5.11426C13.6084 5.11426 13.2328 5.26982 12.9559 5.54673C12.679 5.82364 12.5234 6.19921 12.5234 6.59082ZM12.5234 13.9736C12.5234 14.3652 12.679 14.7408 12.9559 15.0177C13.2328 15.2946 13.6084 15.4502 14 15.4502C14.3916 15.4502 14.7672 15.2946 15.0441 15.0177C15.321 14.7408 15.4766 14.3652 15.4766 13.9736C15.4766 13.582 15.321 13.2065 15.0441 12.9295C14.7672 12.6526 14.3916 12.4971 14 12.4971C13.6084 12.4971 13.2328 12.6526 12.9559 12.9295C12.679 13.2065 12.5234 13.582 12.5234 13.9736ZM12.5234 21.3564C12.5234 21.7481 12.679 22.1236 12.9559 22.4005C13.2328 22.6774 13.6084 22.833 14 22.833C14.3916 22.833 14.7672 22.6774 15.0441 22.4005C15.321 22.1236 15.4766 21.7481 15.4766 21.3564C15.4766 20.9648 15.321 20.5893 15.0441 20.3124C14.7672 20.0354 14.3916 19.8799 14 19.8799C13.6084 19.8799 13.2328 20.0354 12.9559 20.3124C12.679 20.5893 12.5234 20.9648 12.5234 21.3564Z",
    fill: "#052C2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon_menu.144bf26aa8f1cdac141c95a352e776db.svg";
export { ForwardRef as ReactComponent };